import { module as Module } from 'modujs';
import { $screenDebounce } from '../stores/screen';
import { clamp, mapRange } from '../utils/maths';
import BezierEasing from 'bezier-easing';

export default class Explore extends Module {
    static translateEasing = BezierEasing(0.65, 1, 0.9, 1);
    static scaleEasing = BezierEasing(0.65, 1, 0.9, 1);

    constructor(m) {
        super(m);

        // Binding
        this.onResize = this.onResize.bind(this);

        // UI
        this.$children = this.$('children')[0];
        this.$parent = this.$('parent')[0];
        this.$ref = this.$('ref')[0];
        this.$media = this.$('media')[0];

        // Data
        this.mediaMetrics = JSON.parse(this.el.dataset['mediaMetrics']);
        this.idleRatio = 1;
        this.scale = 1;
        this.screenRatio = window.innerHeight / window.innerWidth;
        this.progress = 0;
        this.imageProgress = 0;
        this.clipX = 0;
        this.clipY = 0;
        this.globalTranslate = 0;
        this.wHeight = window.innerHeight;
        this.wWidth = this.el.offsetWidth;
    }

    // =============================================================================
    // Lifecycle
    // =============================================================================
    init() {
        this.bindEvents();
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    // =============================================================================
    // Events
    // =============================================================================
    bindEvents() {
        this.unbindScreenListener = $screenDebounce.subscribe(this.onResize);
    }

    unbindEvents() {
        this.unbindScreenListener?.();
    }

    // =============================================================================
    // Callbacks
    // =============================================================================
    onResize({ width, height }) {
        this.screenRatio = height / width;
        this.idleRatio = this.$ref.offsetWidth / this.el.offsetWidth;
        this.wHeight = height;
        this.wWidth = this.el.offsetWidth;
        this.coverScaleRatio =
            this.wHeight / (this.wWidth * (this.mediaMetrics.height / this.mediaMetrics.width));
        this.coverScaleRatio = Math.max(this.coverScaleRatio, 1);
    }

    onScrollProgress(progress) {
        this.progress = progress;
        this.imageProgress = clamp(0, 1, mapRange(0.1, 1, 0, 1, progress));

        this.setScale();
        this.setClip();
        this.setTranslate();
        this.applyStyles();
    }

    // =============================================================================
    // Methods
    // =============================================================================
    setScale() {
        this.scale = clamp(
            this.idleRatio,
            this.coverScaleRatio,
            mapRange(
                0.5,
                1,
                this.idleRatio,
                this.coverScaleRatio,
                Explore.scaleEasing(this.imageProgress)
            )
        );
    }

    setClip() {
        const width = this.wWidth * this.scale;
        const height = width * (this.mediaMetrics.height / this.mediaMetrics.width);
        this.clipX = (this.wWidth - width) / 2;
        this.clipY = (this.wHeight - height) / 2;
    }

    setTranslate() {
        this.globalTranslate = clamp(
            0,
            100,
            mapRange(0, 0.5, 100, 0, Explore.translateEasing(this.imageProgress))
        );
    }

    applyStyles() {
        this.$media.style.transform = `scale(${this.scale})`;
        this.$parent.style.clipPath = `inset(${this.clipY}px ${this.clipX}px ${this.clipY}px ${this.clipX}px)`;
        this.$children.style.transform = `translate3d(0, ${this.globalTranslate * -1}%, 0)`;
        this.$parent.style.transform = `translate3d(0, ${this.globalTranslate}%, 0)`;
    }
}
